import { IconComponentWrapper } from "../scripts/generate-icons/icon-component-wrapper";
import type { IconProps } from "../scripts/generate-icons/ticon-component-wrapper";

function IconComponent(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      height={24}
      width={36}
      viewBox="0 0 36 24"
      {...props}
    >
      <rect x={0.5} y={0} width={35} height={24} fill="#0F42F8" />
      <g transform="scale(.25) translate(16, 35)">
        <path
          d="M54.0791 25.4791L72.7311 6.84483H58.4186V1.01213H87.3478L68.8322 19.7465H83.3055C84.1307 21.9567 85.6343 24.008 87.701 25.4791H54.0826H54.0791ZM91.4461 15.8443H110.126C110.276 15.0154 110.374 14.1832 110.374 13.2508C110.374 6.05747 105.175 0.331822 97.8417 0.331822C90.0648 0.331822 84.7601 5.95732 84.7601 13.2473C84.7601 20.5373 90.0124 26.1663 98.3348 26.1663C103.09 26.1663 106.808 24.2601 109.136 20.931L103.986 17.9957C102.895 19.415 100.915 20.4407 98.4362 20.4407C95.0688 20.4407 92.3412 19.0697 91.4496 15.8408L91.4461 15.8443ZM91.3481 10.9509C92.093 7.81868 94.4218 6.00912 97.8382 6.00912C100.513 6.00912 103.188 7.42845 103.982 10.9509H91.3481ZM14.6001 0.328369C10.9844 0.328369 8.35825 1.64755 6.57487 3.89913V1.01213H0.179199V33.6566H6.56788V22.5921C8.35125 24.8437 10.9774 26.1628 14.5931 26.1628C21.2335 26.1628 26.6816 20.5373 26.6816 13.2473C26.6885 5.95732 21.237 0.328369 14.6001 0.328369ZM13.4111 20.1437C9.49821 20.1437 6.57487 17.3534 6.57487 13.2439C6.57487 9.1344 9.49821 6.3441 13.4111 6.3441C17.3765 6.3441 20.2964 9.1344 20.2964 13.2439C20.2964 17.3534 17.373 20.1437 13.4076 20.1437H13.4111ZM54.6386 21.5595L50.7152 25.4825H48.2499V22.5955C46.4665 24.7988 43.7915 26.1663 40.1723 26.1663C33.5843 26.1663 28.1327 20.5373 28.1327 13.2473C28.1292 5.95732 33.5808 0.328369 40.1688 0.328369C43.7845 0.328369 46.4595 1.69935 48.2429 3.89913V1.01558H54.6351V21.5595H54.6386ZM48.2464 13.2473C48.2464 9.13785 45.3231 6.34755 41.3612 6.34755C37.4482 6.34755 34.5249 9.1344 34.5249 13.2473C34.5249 17.3568 37.4482 20.1471 41.3612 20.1471C45.3231 20.1471 48.2464 17.3603 48.2499 13.2473H48.2464Z"
          fill="white"
        />
      </g>
    </svg>
  );
}
const IconComponentWrapped = (props: IconProps) => {
  return (
    <IconComponentWrapper data-testid="icon-paze" {...props}>
      <IconComponent />
    </IconComponentWrapper>
  );
};
export default IconComponentWrapped;
